import { TableColumnDefinition } from '@antimatterhq/ui/types/TableColumnDefinition';

export const TABLE_COLUMN_PINNED_STORAGE_KEY = 'table-column-pinned';
export const TABLE_COLUMN_ORDER_STORAGE_KEY = 'table-column-order';
export const TABLE_COLUMN_VISIBILITY_STORAGE_KEY = 'table-column-visibility';
export const TABLE_COLUMN_WIDTH_STORAGE_KEY = 'table-column-width';
export const TABLE_MAX_COLUMN_WIDTH = 1500;
export const TABLE_MIN_COLUMN_WIDTH = 60;
export const TABLE_COLUMN_HEADER_ICON_WIDTH = 16;
export const TABLE_CELL_HEIGHT = 35;
export const TABLE_SELECT_COLUMN_ID = 'table-select';
export const TABLE_DEFAULT_PAGE_SIZE = 10;
export const VIRTUALIZED_TABLE_DEFAULT_PAGE_SIZE = 50;

export const SELECT_COLUMN_DEFINITION_ITEM: TableColumnDefinition = {
  id: TABLE_SELECT_COLUMN_ID,
  title: '',
  tooltip: false,
  width: 40,
  enableFiltering: false,
  enableSorting: false,
  enableResize: false,
  pinned: 'left',
};
